import { Component, Injectable, EventEmitter, Output } from "@angular/core";
import { SignalsMainComponent } from "./main.component";


@Component({
  selector: "app-signals-scheduled",
  template: `<app-signals-messages [isScheduled]='true' [isUserQuestion]='true' title="Scheduled User Questions"></app-signals-messages>`,
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsUserQuestionComponent extends SignalsMainComponent {
  
  }





// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsUserQuestion.component.ts